import { render, staticRenderFns } from "./demandBase.vue?vue&type=template&id=75b1a6d0"
import script from "./demandBase.vue?vue&type=script&lang=ts"
export * from "./demandBase.vue?vue&type=script&lang=ts"
import style0 from "./demandBase.vue?vue&type=style&index=0&id=75b1a6d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports